export default __webpack_public_path__ + "static/img/add_phone_step_3.3445ac1.svg";